<template>
  <b-modal id="BSSetSaleAmountCombinedID" centered size="lg" @show="fillLocal" @hide="clearlocal">
    <template #modal-header>
      <h2 class="modal-title">{{ $t("labels.week") }} {{ factuur.week }}</h2>
      {{ factuur_id }}
    </template>

    <form class="form" v-if="factuur_id != 0">
      <div class="form-row">
        <div class="col-3">
          <label for=""> {{ $t("labels.amount") }}</label>
        </div>
        <div class="col">
          <b-form-input class="form-control" v-model="saleamount" />
        </div>
      </div>
    </form>
    <template #modal-footer>
      <div @click="saveData" class="btn btn-primary">
        {{ $t("buttons.saveandclose") }}
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  name: "invoice-data-modal",
  data() {
    return {
      saleamount: null,
    };
  },
  props: {
    factuur_id: Number,
  },
  computed: {
    ...mapGetters(["server_url", "combinedfactuur_by_id"]),
    ...mapState(["combinedfacturen", "branches", "avatars", "urenbonnen"]),
    factuur() {
      //   console.log("<<<<<<<", this.combinedfactuur_by_id(this.factuur_id));
      return this.factuur_id == 0 ? null : this.combinedfactuur_by_id(this.factuur_id);
    },
  },
  methods: {
    ...mapActions(["save_combinedfactuur"]),
    fillLocal() {
      if (this.factuur_id != 0) {
        this.saleamount = this.factuur.invoiceamountsale;
      }
    },
    clearlocal() {
      // this.senddate = null
      this.saleamount = null;
    },
    async saveData() {
      this.factuur.invoiceamountsale = this.saleamount;
      this.save_combinedfactuur(this.factuur.id);
      //   await axios.post("/api/set_manual_invoice", { id: this.factuur_id, senddate: this.senddate, facnuminkoop: this.facnuminkoop });

      this.close_modal();
    },

    close_modal() {
      this.$bvModal.hide("BSSetSaleAmountCombinedID");
    },
  },
  watch: {
    factuur_id() {
      this.fillLocal();
    },
  },
};
</script>
